/**
 * A verdict block at the bottom of the tab it belongs to.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';

import { StepCardGroup } from '@/components/ui';
import { cn } from '@/lib/utils';

interface Props {
  title: string;
  hint: string;
  titleClass: string;
  children: ReactNode;
}

export const VerdictHome: FC<Props> = ({ title, hint, titleClass, children }) => (
  <section className="flex flex-col gap-2 border-t border-border/70 pt-4">
    <div>
      <h3 className={cn('text-[11px] font-semibold uppercase tracking-wider', titleClass)}>{title}</h3>
      <p className="text-xs text-muted-foreground">{hint}</p>
    </div>
    <StepCardGroup>{children}</StepCardGroup>
  </section>
);
